var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"input",staticClass:"component__input-number",attrs:{"value":_vm.displayValue,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"size":_vm.size,"max":_vm.max,"min":_vm.min},on:{"blur":_vm.handleBlur,"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }